module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/november/mainvisual-present-sp_a5dc6966032ab1b13fb7c3be1f585947.webp";